import { AfterViewInit, Component, ContentChild, ElementRef, inject, input, Input, InputSignal, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormField,
  MatFormFieldAppearance,
  MatFormFieldControl,
  MatFormFieldModule,
} from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import * as deTranslations from '../assets/i18n/de-lang.json';
import * as enTranslations from '../assets/i18n/en-lang.json';

@Component({
  selector: 'spx-form-field',
  templateUrl: './form-field.component.html',
  styles: 'mat-form-field { width: 100% }',
  imports: [MatInputModule, MatFormFieldModule, TranslateModule],
})
export class FormFieldComponent implements AfterViewInit {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @ContentChild(MatFormFieldControl) _control!: any;
  @ViewChild(MatFormField) _matFormField!: MatFormField;
  @Input() name?: string;
  @Input() label = '';
  public hintAlign: InputSignal<'start' | 'end'> = input<'start' | 'end'>('start');
  public hint: InputSignal<string> = input<string>('');
  element!: HTMLElement;
  public fieldControl!: FormControl;
  @ViewChild('dummyInput') private dummyInput!: ElementRef;
  private defaultOptions = inject(MAT_FORM_FIELD_DEFAULT_OPTIONS, { optional: true }) as { appearance?: MatFormFieldAppearance } | null;
  public appearance: InputSignal<MatFormFieldAppearance> = input<MatFormFieldAppearance>(this.defaultOptions?.appearance || 'fill');
  private onBlur = () => {
    this.element.removeEventListener('blur', this.onBlur);
    this.element.click();
    this.element.blur();
  };

  constructor(private translateService: TranslateService) {
    this.translateService.setTranslation('en', enTranslations, true);
    this.translateService.setTranslation('de', deTranslations, true);
  }

  get fieldName() {
    return this.name ? this.name : this.translateService.instant('FORM_FIELD.FIELD');
  }

  ngAfterViewInit() {
    this.element = this._control._elementRef.nativeElement;
    this.element.classList.add(
      'mat-mdc-input-element',
      'mat-mdc-form-field-input-control',
      'mdc-text-field__input',
      'cdk-text-field-autofill-monitored',
    );

    this.element.addEventListener('blur', this.onBlur);

    setTimeout(() => {
      this._matFormField._control = this._control;
      this.fieldControl = this._matFormField._control.ngControl?.control as unknown as FormControl;
      this.dummyInput.nativeElement.remove();

      /* eslint-disable @angular-eslint/no-lifecycle-call*/
      this._matFormField.ngAfterContentInit();
      this._matFormField.ngAfterContentChecked();
      this._matFormField.ngAfterViewInit();
      /* eslint-enable @angular-eslint/no-lifecycle-call*/
    });
  }
}
